import "./styles.css";
import PASTEJOLogo from "../../../assets/png/logo.png";
import CNPQLogo from "../../../assets/png/logo/cnpq.png";
import EMBRAPIILogo from "../../../assets/png/logo/embrapii.png";
import IFGoianoLogo from "../../../assets/png/logo/if-goiano.png";

export function Footer() {
  return (
    <footer className="footer">
      <img src={PASTEJOLogo} alt="logo pastejo" height={120} />
      <img src={CNPQLogo} alt="logo pastejo" height={50}/>
      <img src={EMBRAPIILogo} alt="logo pastejo" height={120} />
      <img src={IFGoianoLogo} alt="logo pastejo" height={130}/>  
    </footer>
  );
}
